import React, { useState } from 'react';
import { Button } from './ui/button';
import { ExternalLink, ChevronLeft, ChevronRight } from 'lucide-react';
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from './ui/carousel';

const FeedbackSlider = () => {
  const [api, setApi] = useState();

  const feedbackImages = [
    {
      id: 1,
      imageUrl: "/feedback-1.jpg",
      alt: "Feedback Indikator SBE 1"
    },
    {
      id: 2,
      imageUrl: "/feedback-2.jpg",
      alt: "Feedback Indikator SBE 2"
    },
    {
      id: 3,
      imageUrl: "/feedback-3.jpg",
      alt: "Feedback Indikator SBE 3"
    },
    {
      id: 4,
      imageUrl: "/feedback-4.jpg",
      alt: "Feedback Indikator SBE 4"
    }
  ];

  const handleSubscribe = () => {
    // Track Subscribe event with Facebook Pixel
    if (window.fbq) {
      window.fbq('track', 'Subscribe', {
        source: 'feedback_slider',
        value: 1,
        currency: 'USD'
      });
    }
    window.open('https://t.me/sinyalbankentry/12328', '_blank');
  };

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold mb-4 text-black">
              Masih Penasaran Pakai Indikator SBE?{' '}
              <span className="text-[#ED1C24]">Lihat Buktinya!</span>
            </h2>
            <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
              Ini bukan cerita rekaan. Real results dari trader yang konsisten pakai Indikator SBE!
            </p>
          </div>
          
          <div className="relative px-12 md:px-0">
            <Carousel
              className="w-full max-w-5xl mx-auto"
              setApi={setApi}
              opts={{
                align: "start",
                loop: true,
              }}
            >
              <CarouselContent className="-ml-2 md:-ml-4">
                {feedbackImages.map((feedback) => (
                  <CarouselItem key={feedback.id} className="pl-2 md:pl-4 basis-full sm:basis-1/2 md:basis-1/3">
                    <div className="bg-gradient-to-br from-gray-100 to-white rounded-2xl p-3 border-2 border-gray-200 hover:border-[#ED1C24] transition-all hover:shadow-xl group max-w-[200px] sm:max-w-xs mx-auto md:max-w-none">
                      <img
                        src={feedback.imageUrl}
                        alt={feedback.alt}
                        className="w-full h-auto rounded-xl object-cover group-hover:scale-105 transition-transform"
                      />
                    </div>
                  </CarouselItem>
                ))}
              </CarouselContent>
              <CarouselPrevious className="hidden md:flex left-0 md:-left-12 bg-[#ED1C24] hover:bg-[#c91820] text-white border-0" />
              <CarouselNext className="hidden md:flex right-0 md:-right-12 bg-[#ED1C24] hover:bg-[#c91820] text-white border-0" />
            </Carousel>

            {/* Mobile Navigation Buttons - Positioned at the sides of carousel */}
            <button
              onClick={() => api?.scrollPrev()}
              className="md:hidden absolute left-0 top-1/2 -translate-y-1/2 bg-[#ED1C24] hover:bg-[#c91820] text-white border-0 w-12 h-12 rounded-full flex items-center justify-center transition-colors shadow-lg z-10"
              aria-label="Previous feedback"
            >
              <ChevronLeft className="w-6 h-6" />
            </button>
            <button
              onClick={() => api?.scrollNext()}
              className="md:hidden absolute right-0 top-1/2 -translate-y-1/2 bg-[#ED1C24] hover:bg-[#c91820] text-white border-0 w-12 h-12 rounded-full flex items-center justify-center transition-colors shadow-lg z-10"
              aria-label="Next feedback"
            >
              <ChevronRight className="w-6 h-6" />
            </button>
          </div>

          <div className="text-center mt-12">
            <Button
              onClick={handleSubscribe}
              className="bg-[#ED1C24] hover:bg-[#c91820] text-white px-8 py-6 text-lg font-bold rounded-xl transition-all hover:scale-105 shadow-lg"
            >
              Lihat Lebih Banyak Testimoni
              <ExternalLink className="ml-2 w-5 h-5" />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeedbackSlider;